import { useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'
import { useAuth } from '@/lib/contexts/AuthContext'
import { track } from '@/lib/utils/track'
import { getPageInfo } from '@/lib/utils/pageNames'

export function usePageTracking() {
  const location = useLocation()
  const { token } = useAuth()
  const lastTracked = useRef<string | null>(null)

  useEffect(() => {
    const key = location.pathname
    if (key === lastTracked.current) return
    lastTracked.current = key

    const { page_name, path_pattern } = getPageInfo(location.pathname)
    track('page_viewed', token, { page_name, path_pattern })
  }, [location.pathname, token])
}
